import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowRight"><Path fillRule="evenodd" clipRule="evenodd" d="M14 4.37866L21.6213 12L14 19.6213L11.8787 17.5L15.8787 13.5H3V10.5H15.8787L11.8787 6.49999L14 4.37866Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRight;
